import SyosUiContainer from './SyosUiContainer';
import SyosPageComponent from './components/SyosPageComponent';
import SyosKeyCommandsModal from './modals/SyosKeyCommandsModal';
import IconSprites from '../utils/IconSprites';
import SvgIcon from '../utils/SvgIcon';
import type SyosController from './SyosController';

const Key = {
  F1: 112,
  alt: 18,
};

const getHtml = () => `
  <button type="button" class="btn btn-default tn-syos-btn-view-key-commands" aria-label="Keyboard Shortcuts (Alt+F1)">
    ${SvgIcon.getHtml(IconSprites.Keyboard, 'tn-syos-btn-view-key-commands__icon')}
    <span class="tn-syos-btn-view-key-commands__label">${SyosPageComponent.labelAvailableKeyCommands}</span>
    <kbd class="tn-syos-btn-view-key-commands__command" aria-hidden="true">Alt + F1</kbd>
  </button>
`;

class SyosBtnViewKeyCommands extends SyosUiContainer {
  static DesktopContainerClassName = 'tn-syos-btn-view-key-commands__container--desktop';

  static MobileContainerClassName = 'tn-syos-btn-view-key-commands__container--mobile';

  keyCodes: Set<number>;

  $btn: JQuery<HTMLButtonElement>;

  constructor(syosController: SyosController, containerSelector: string) {
    super(syosController, containerSelector);

    this.$el.html(getHtml());

    this.$btn = this.$el.find('button');

    this.keyCodes = new Set<number>();

    this.$btn.on('click', this.openModal);

    document.body.addEventListener('keydown', this.onKeyDown);
    document.body.addEventListener('keyup', this.onKeyUp);
  }

  onKeyDown = (event: KeyboardEvent) => {
    const key = event.keyCode || event.charCode;

    this.keyCodes.add(key);
  };

  onKeyUp = (event: KeyboardEvent) => {
    if (this.keyCodes.has(Key.alt) && this.keyCodes.has(Key.F1)) {
      event.preventDefault();

      this.openModal();
    }

    this.keyCodes.clear();
  };

  openModal = () => {
    SyosKeyCommandsModal.open(this.syosController);
  };

  destroy() {
    document.body.removeEventListener('keydown', this.onKeyDown);
    document.body.removeEventListener('keyup', this.onKeyUp);

    this.$btn.off();

    super.destroy();
  }
}

export default SyosBtnViewKeyCommands;
